// extracted by mini-css-extract-plugin
export default {"section":"RelatedProducts_section__DA9CC","title":"RelatedProducts_title__WBZ7F"};